import React, { useState, useEffect, useContext } from 'react';
import OnceFooter from "./common/Footer/OnceFooter";
import Menu from "./common/Menu/Menu";
import Services from "./HomeSection/Services";
import SliderHome from "./HomeSection/SliderHome";
import TopCtaArea from "./HomeSection/TopCtaArea";
import TopCtaAreaForCloseAll from "./HomeSection/TopCtaAreaForCloseAll";
import { useParams, useLocation } from 'react-router-dom';
import api from './../utils/api';
import { AppContext } from "./context/ContextProvider";
import { Button } from 'react-bootstrap';
import BookingPriceSummary from "./Booking/BookingPriceSummary";
import ReactGA from 'react-ga4';
import { useTranslation } from 'react-i18next'
import { transformFieldWithLang } from '../utils/functions';

export default function Home() {
  const { id, is_booking, s_date, e_date, hotel_id, agent_key } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const qStartDate = searchParams.get('s_date');
  const qEndDate = searchParams.get('e_date');
  const qBookingData = searchParams.get('book_data');
  const { t, i18n } = useTranslation()
  const lang = i18n.language || 'th'

  const isFlex = location.pathname?.includes("/type/");

  const [currentRoom, setCurrentRoom] = useState({})
  const { hotel } = currentRoom
  const { handleSetRoomSelected, currentHotel, handleSetCurrentHotel,
    handleSetBookStartDate,
    handleSetBookEndDate,
    handleSetBookingData,
    setAgentCodekey, clearAgentCodekey,
  } = useContext(AppContext);

  const [forceShowBookingModal, setForceShowBookingModal] = useState(false)
  const [hotelNearbyPlaces, setHotelNearbyPlaces] = useState([])
  const [hotelImages, setHotelImages] = useState([])
  const [hotelCloseAllImages, setHotelCloseAllImages] = useState([])
  const [roomImages, setRoomImages] = useState([])

  const fetchHotelData = (hotelId, rData) => {
    api.request(`hotels/${hotelId}`, (data) => {
      handleSetCurrentHotel(data)

      ReactGA.send({ hitType: "pageview", page: `once/${id}`, title: `Room - ${data?.name_th} : ${rData?.name_th}` });

      // ReactGA.event({
      //   category: "Room",
      //   action: "View",
      //   label: `page - ${data?.name_th} : ${rData?.name_th}`,
      // });
    }, {})
  }

  const fetchHotelImages = (hotelId) => {
    api.request(`hotels/media/all`, (res) => {
      if (res && res.length) {
        setHotelImages(res.map((item) => { return item.file_path }))
      } else {
        setHotelImages([])
      }
    }, {
      hotel_id: hotelId,
      used_type: 'hotel'
    })
  }

  const fetchHotelCloseAllImages = (hotelId) => {
    api.request(`hotels/media/all`, (res) => {
      if (res && res.length) {
        setHotelCloseAllImages(res.map((item) => { return item.file_path }))
      } else {
        setHotelCloseAllImages([])
      }
    }, {
      hotel_id: hotelId,
      used_type: 'closezone'
    })
  }

  const fetchRoomImages = (roomId) => {
    api.request(`${isFlex ? 'room-flexibles' : 'rooms'}/media/all`, (res) => {
      if (res && res.length) {
        setRoomImages(res.map((item) => { return item.file_path }))
      } else {
        setRoomImages([])
      }
    }, {
      room_id: !isFlex ? roomId : null,
      room_flexible_type_id: isFlex ? roomId : null
    })
  }

  const fetchHotelNearbyPlaces = (hotelId) => {
    api.request(`hotel-nearby-places/all`, (data) => {
      setHotelNearbyPlaces(data || [])
    }, {
      hotel_id: hotelId
    })
  }

  const fetchRoomData = () => {
    api.request(`${isFlex ? 'room-flexibles' : 'rooms'}/${id}`, (data) => {
      if (!data || data.enabled === false || data.hotel?.enabled === false) {
        alert(`${t('link_incorrect')} !`)
        window.location.replace("https://www.onceinmemory.com");
        return
      }

      fetchRoomImages(data.id)
      fetchHotelData(data.hotel_id, data)
      fetchHotelImages(data.hotel_id)
      fetchHotelCloseAllImages(data.hotel_id)
      fetchHotelNearbyPlaces(data.hotel_id)
      setCurrentRoom({
        ...data,
        _type: isFlex ? 'room_flexible' : 'room'
      })
      handleSetRoomSelected({
        ...data,
        _type: isFlex ? 'room_flexible' : 'room'
      })

      if (!!qBookingData && !!qStartDate && !!qEndDate) {
        const bookingData = JSON.parse(qBookingData)
        const startDate = new Date(qStartDate)
        const endDate = new Date(qEndDate)

        handleSetBookStartDate(startDate)
        handleSetBookEndDate(endDate)
        handleSetBookingData(bookingData)
        setForceShowBookingModal(true)
      }
    }, {})
  }

  const fetchHotelDataForCloseAll = () => {
    api.request(`hotels/${hotel_id}`, (data) => {
      if (!data) {
        alert(`${t('link_incorrect')} !`)
        window.location.replace("https://www.onceinmemory.com");
        return
      }

      handleSetCurrentHotel(data)
    }, {})
  }

  useEffect(() => {
    if (!id) {
      return
    }

    fetchRoomData()
  }, [id])

  useEffect(() => {
    if (!hotel_id) {
      return
    }

    fetchHotelDataForCloseAll()
    fetchHotelNearbyPlaces(hotel_id)
    fetchHotelImages(hotel_id)
    fetchHotelCloseAllImages(hotel_id)
  }, [hotel_id])

  useEffect(() => {
    if (!agent_key) {
      return
    }

    api.request('sale-agents/agent-key', (data) => {
      if (data) {
        setAgentCodekey({
          id: data.id,
          code: data.code,
          firstname: data.firstname,
          lastname: data.lastname,
        })
      } else {
        clearAgentCodekey()
      }
    }, { _key: agent_key });
  }, [agent_key])

  return (
    <>
      <Menu header_style_2={true} />
      {!hotel_id && <TopCtaArea nearbyPlaces={hotelNearbyPlaces} roomImages={roomImages} />}
      {!!hotel_id && <TopCtaAreaForCloseAll nearbyPlaces={hotelNearbyPlaces} images={[...hotelImages, ...hotelCloseAllImages]} />}
      {!!hotelImages?.length && <SliderHome images={hotelImages} />}
      <Services />
      <div id="map" >
        {/* todo custom map marker */}
        {!!currentHotel?.map_file_path && <img src={currentHotel?.map_file_path} alt="img" />}
        {!!((currentRoom?.latitude && currentRoom?.longitude) || (currentHotel?.latitude && currentHotel?.longitude)) && <div className="tp-ct-map">
          <iframe
            title="map"
            src={`https://maps.google.com/maps?q=${currentRoom?.latitude || currentHotel?.latitude},${currentRoom?.longitude || currentHotel?.longitude}&z=15&output=embed`}
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>}
      </div>
      <OnceFooter />
      <BookingPriceSummary forceShowBookingModal={forceShowBookingModal} is_close_all={!!hotel_id} is_flex={isFlex} />
    </>
  );
}
